@if (person?.referencePattern) {
    <div class="my-ba-profile-container" piTesting="my-ba-profile">
        @if (showCoverView) {
            <div class="cover-view-container color-neutral-900">
                @if (person.referencePattern) {
                    <abstract-icon
                        [iconType]="
                            person.referencePattern.icon.abstractIconSVG
                        "
                        [iconSize]="90"
                        title="{{
                            person.referencePattern.key | translate | titlecase
                        }}"
                        style="min-width: 70px"
                    >
                    </abstract-icon>
                }
                <div class="reference-title-container">
                    <div class="title-prefix">
                        {{ 'myBAProfile.title.prefix' | translate | uppercase }}
                    </div>
                    <div class="reference-profile-title">
                        {{
                            person.referencePattern.key | translate | titlecase
                        }}
                    </div>
                </div>
                <div class="line-separator">
                    <!-- Line div -->
                </div>
                <div class="reference-profile-description">
                    {{ getReferencePatternDesc(person) }}
                </div>
                <button
                    (click)="viewYourProfileClicked($event)"
                    class="button button-white button-md"
                    piTesting="my-ba-profile-button"
                >
                    {{ 'myBAProfile.button.viewProfile' | translate }}
                </button>
            </div>
        } @else {
            <div
                class="details-view-container"
                piTesting="my-ba-profile-details"
            >
                @if (!insightsLoading) {
                    <div class="details-reference-description copy-md-light">
                        {{ getReferencePatternDesc(person) }}
                    </div>
                }
                <pattern-insights
                    (loading)="updateInsightsLoading($event)"
                    [person]="person"
                ></pattern-insights>
            </div>
        }
    </div>
}
